import axios from 'axios';
import { trackEvent } from './analytics';

/**
 * Same-origin Worker route. In CRA `npm start`, package.json "proxy"
 * forwards /api to wrangler (http://127.0.0.1:8787).
 */
const ENQUIRY_URL = '/api/enquiries';

export async function submitEnquiry(payload) {
  const response = await axios.post(
    ENQUIRY_URL,
    { company: '', ...payload },
    { timeout: 15000 },
  );
  trackEvent('generate_lead', {
    event_category: 'lead',
    lead_source: payload.source || 'other',
    project_type: payload.project_type || 'residential',
  });
  return response;
}
